<template>
  <div class="withdrawal-container">
    <!-- 顶部导航栏 -->
    <div >
      <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ffffff" title="提现" left-arrow @click-left="$router.back()" />
    </div>

    <!-- 提款方式选择 -->
    <div class="withdrawal-methods">
      <div class="methods-title">选择提款方式</div>
      <div class="methods-list">
        <div
            v-for="method in withdrawalMethods"
            :key="method.type"
            class="method-item"
            :class="{ 'disabled': !hasBound(method.type) }"
            @click="handleMethodClick(method)"
        >
          <div class="method-content">
            <div class="method-icon" :class="method.type.toLowerCase()">
              {{ getMethodSymbol(method.type) }}
            </div>
            <div class="method-info">
              <div class="method-name">{{ method.name }}</div>
              <div v-if="!hasBound(method.type)" class="method-status">未绑定</div>
            </div>
          </div>
          <div class="method-arrow">
            <svg viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
          </div>
        </div>
      </div>



      <div class="balance-info">
        可提款余额: {{ $store.state.userInfo.balance }}元，可回收余额:{{ $store.state.userInfo.gameblance }}元
      </div>
    </div>

    <!-- 提款表单弹窗 -->
    <transition name="slide-up">
      <div v-if="open_tixian" class="withdrawal-modal">
        <div class="modal-overlay" @click="open_tixian = false"></div>

        <div class="modal-content">
          <!-- 模态框头部 -->
          <div class="modal-header">
            <div class="header-back" @click="open_tixian = false">
              <svg viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
            </div>
            <div class="header-title">通用提现①</div>
            <div class="header-action" @click="navigateToBinding">
              <span>管理</span>
            </div>
          </div>

          <!-- 提款步骤指示器 -->
          <div class="withdrawal-steps">
            <div class="step active">
              <div class="step-circle">1</div>
              <div class="step-label">设置提款请求</div>
            </div>
            <div class="step">
              <div class="step-circle">2</div>
              <div class="step-label">确认到账后完成提款</div>
            </div>
          </div>

          <!-- 提款限额提示 -->
          <div class="withdrawal-limit">
            每天限制提款5次，您今日剩余提款额度为<span>200000.00</span>元
          </div>

          <!-- 提款表单 -->
          <div class="withdrawal-form">
            <!-- 可提现额度 -->
            <div class="form-section">
              <div class="section-title">当前可提现额度</div>
              <div class="section-value">¥{{ $store.state.userInfo.balance }}</div>
            </div>

            <!-- 选择银行卡/账户 -->
            <div class="form-section">
              <div class="section-title">选择提款账户</div>
              <div class="account-list">
                <div
                    v-for="(item, index) in usercardLis"
                    :key="index"
                    class="account-item"
                    :class="{ 'active': bankId == item.id }"
                    @click="changApiType(item)"
                >
                  <div class="account-icon" :class="item.bank.toLowerCase()">
                    {{ formatAccountSymbol(item.bank) }}
                  </div>
                  <div class="account-details">
                    <div class="account-type">{{ formatAccountType(item.bank) }}</div>
                    <div class="account-number">**** **** **** {{ item.bank_no.substr(-4) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 提现金额 -->
            <div v-if="$store.state.userInfo.balance > 0" class="form-section">
              <div class="section-title">输入提现金额</div>
              <div class="amount-input">
                <span class="prefix">¥</span>
                <input
                    v-model="amount"
                    type="number"
                    placeholder="请输入提款金额"
                    inputmode="numeric"
                    @input="validateAmount"
                >
                <button class="clear-btn" @click="amount = null">×</button>
              </div>
              <div class="input-hint">若输入金额非整数，为加快提现速度，将自动取整数</div>
            </div>

            <!-- 资金密码 -->
            <div v-if="$store.state.userInfo.balance > 0" class="form-section">
              <div class="section-title">资金密码 <span class="required">*</span></div>
              <div class="password-input">
                <input
                    v-model="password"
                    type="password"
                    placeholder="请输入密码"
                >
                <button class="clear-btn" @click="password = null">×</button>
              </div>
              <div class="input-hint">(必填)如忘记支付密码，请联系客服</div>
            </div>

            <!-- 本次提现金额 -->
            <div v-if="amount > 0" class="form-section">
              <div class="section-title">本次提现金额</div>
              <div class="confirm-amount">¥{{ amount }}</div>
            </div>

            <!-- 注意事项 -->
            <div class="form-notice">
              <div class="notice-icon">!</div>
              <div class="notice-content">
                您发起提现后，平台会为您<span>暂时冻结保证金</span>，待提现完成后保证金会返还您的钱包，请您收到提现后即时点击「<span>确认到帐</span>」，否则<span>保证金将暂时不会自动返还</span>。
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="form-actions">
              <button class="action-btn tutorial-btn" @click="$parent.goNav('/wenInfo?id=24')">提现教程指引</button>
              <button class="action-btn record-btn" @click="$parent.goNav('/transRecord')">订单记录</button>
              <button
                  class="action-btn submit-btn"
                  :disabled="!canSubmit"
                  @click="withdraw"
              >
                立即提现
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 未绑定提示弹窗 -->
    <transition name="fade">
      <div v-if="is_msg" class="binding-modal">
        <div class="modal-overlay" @click="is_msg = false"></div>

        <div class="modal-content">
          <div class="modal-header">
            <div class="header-title">温馨提示</div>
            <button class="close-btn" @click="is_msg = false">
              <svg viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
            </button>
          </div>

          <div class="modal-body">
            <div class="modal-message">请先绑定个人信息</div>
          </div>

          <div class="modal-actions">
            <button class="action-btn" @click="navigateToBinding">{{ is_msg_txt }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Withdrawal',
  data() {
    return {
      open_tixian: false,
      is_msg: false,
      is_type: '',
      is_msg_txt: '',
      usercardLis: [],
      amount: null,
      bankId: null,
      password: null,
      withdrawalMethods: [
        { type: 'BANK', name: '银行卡提款' },
        { type: 'WX', name: '微信提款' },
        { type: 'ZFB', name: '支付宝提款' },
        { type: 'XZRMB', name: '数字人民币提款' },
        { type: 'USDT', name: 'USDT提款' }
      ],
      zhanghuxinxi: {}
    };
  },
  computed: {
    canSubmit() {
      return this.bankId && this.amount >= 100 && this.password;
    },
    hasBound() {
      return (type) => {
        switch (type) {
          case 'BANK': return this.zhanghuxinxi.bank_count > 0;
          case 'WX': return this.zhanghuxinxi.wx_count > 0;
          case 'ZFB': return this.zhanghuxinxi.zfb_count > 0;
          case 'USDT': return this.zhanghuxinxi.usdt_count > 0;
          case 'XZRMB': return this.zhanghuxinxi.xzrmb_count > 0;
          default: return false;
        }
      };
    }
  },
  created() {
    this.openzhanghu();
  },
  methods: {
    // 获取账户信息
    openzhanghu() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/zhanghuxinxi', {})
          .then(res => {
            if (res.code === 200) {
              this.zhanghuxinxi = res.data;
            } else {
              this.$parent.showTost(0, res.message);
            }
          })
          .finally(() => {
            this.$parent.hideLoading();
          });
    },

    // 获取银行卡/账户列表
    getUsercard() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/getcard', { type: this.is_type })
          .then(res => {
            if (res.code === 200) {
              this.usercardLis = res.data;
              if (res.data.length > 0) {
                this.changApiType(res.data[0]);
                this.open_tixian = true;
              }
            }
          })
          .finally(() => {
            this.$parent.hideLoading();
          });
    },

    // 处理提款方式点击
    handleMethodClick(method) {
      this.is_type = method.type;

      if (!this.hasBound(method.type)) {
        this.is_msg = true;
        this.is_msg_txt = `绑定${method.name.replace('提款', '')}`;
        return;
      }

      this.getUsercard();
    },

    // 格式化账户类型显示
    formatAccountType(type) {
      switch (type) {
        case 'WX': return '微信';
        case 'ZFB': return '支付宝';
        case 'XZRMB': return '数字人民币';
        default: return type;
      }
    },

    // 获取提款方式符号
    getMethodSymbol(type) {
      const symbols = {
        BANK: '卡',
        WX: '微',
        ZFB: '支',
        XZRMB: '数',
        USDT: 'U'
      };
      return symbols[type] || '提';
    },

    // 格式化账户符号
    formatAccountSymbol(type) {
      const symbols = {
        BANK: '卡',
        WX: '微',
        ZFB: '支',
        XZRMB: '数'
      };
      return symbols[type] || '账';
    },

    // 选择提款账户
    changApiType(item) {
      this.bankId = item.id;
      this.password = null;
      this.amount = null;
    },

    // 验证金额输入
    validateAmount() {
      if (this.amount < 0) {
        this.amount = Math.abs(this.amount);
      }
      if (this.amount > this.$store.state.userInfo.balance) {
        this.amount = this.$store.state.userInfo.balance;
      }
    },

    // 提款操作
    withdraw() {
      if (!this.canSubmit) return;

      this.$parent.showLoading();
      this.$apiFun.post('/api/withdraw', {
        amount: this.amount,
        bank: this.bankId,
        password: this.password
      })
          .then(res => {
            if (res.code === 200) {
              this.$parent.showTost(1, '提交成功，等待后台审核');
              setTimeout(() => {
                this.$router.push('/transRecord');
              }, 1500);
            } else {
              this.$parent.showTost(0, res.message);
            }
          })
          .finally(() => {
            this.$parent.hideLoading();
          });
    },

    // 导航到绑定页面
    navigateToBinding() {
      this.open_tixian = false;

      const routes = {
        BANK: '/addBankCard',
        WX: '/bindwx',
        ZFB: '/bindzfb',
        USDT: '/addUsdtCard',
        XZRMB: '/bindxzrmb'
      };

      if (routes[this.is_type]) {
        this.$router.push(routes[this.is_type]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 字体规范系统
$font-size-xxl: 1rem;   // 超大标题
$font-size-xl: 0.7rem;   // 大标题/重要操作
$font-size-lg: 0.7rem;      // 次级标题/正文强调
$font-size-md: 0.7rem;    // 常规正文
$font-size-sm: 0.7rem;    // 辅助说明
$font-size-xs: 0.7rem;   // 极小说明

$color-title: #333;       // 主标题
$color-primary: #a7739a;  // 品牌主色
$color-secondary: #666;   // 次级文字
$color-tip: #999;         // 提示文字
$color-disabled: #ccc;    // 禁用状态
$color-danger: #ff4757;   // 错误提示

/* 基础样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.withdrawal-container {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f6fa;
  min-height: 100vh;
  color: $color-title;
}

/* 顶部导航栏样式 */
.withdrawal-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2.8rem;
  background: linear-gradient(135deg, #a7739a, #8a5a8a);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .header-back, .header-right {
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1rem;
      height: 1rem;
      fill: white;
    }
  }

  .header-title {
    font-size: $font-size-xxl;
    font-weight: 600;
    flex: 1;
    text-align: center;
  }
}

/* 提款方式选择区域 */
.withdrawal-methods {
  padding: 3.5rem 1rem 1rem;

  .methods-title {
    font-size: $font-size-xl;
    font-weight: 500;
    margin-bottom: 1rem;
    color: $color-title;
  }

  .methods-list {
    background: white;
    border-radius: 0.8rem;
    overflow: hidden;
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .method-item {
    padding: 1rem;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s ease;

    &:last-child {
      border-bottom: none;
    }

    &:not(.disabled):active {
      background-color: #f9f9f9;
    }

    &.disabled {
      opacity: 0.6;
    }

    .method-content {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .method-icon {
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.8rem;
      font-size: $font-size-md;
      font-weight: bold;
      color: white;

      &.bank { background: #4a6baf; }
      &.wx { background: #2aae67; }
      &.zfb { background: #1677ff; }
      &.xzrmb { background: #9c27b0; }
      &.usdt { background: #26a17b; }
    }

    .method-info {
      flex: 1;

      .method-name {
        font-size: $font-size-lg;
        font-weight: 500;
        color: $color-title;
      }

      .method-status {
        font-size: $font-size-sm;
        color: $color-danger;
        margin-top: 0.2rem;
      }
    }

    .method-arrow {
      width: 1rem;
      height: 1rem;

      svg {
        width: 100%;
        height: 100%;
        fill: $color-tip;
      }
    }
  }

  .usdt-tutorial {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-primary;
    font-size: $font-size-md;
    margin-bottom: 1rem;
    text-decoration: underline;

    svg {
      width: 0.8rem;
      height: 0.8rem;
      margin-left: 0.3rem;
      fill: $color-primary;
    }
  }

  .balance-info {
    background: white;
    border-radius: 0.8rem;
    padding: 1rem;
    font-size: $font-size-md;
    text-align: center;
    color: $color-secondary;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
}

/* 提款表单弹窗 */
.withdrawal-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;

  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-content {
    position: relative;
    background: white;
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
    padding: 1rem;
    margin-top: auto;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.1);
    animation: slide-up 0.3s ease-out;
  }

  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0;
    margin-bottom: 1rem;

    .header-back, .header-action {
      width: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 1rem;
        height: 1rem;
        fill: $color-secondary;
      }
    }

    .header-title {
      font-size: $font-size-xl;
      font-weight: 500;
      flex: 1;
      text-align: center;
    }

    .header-action {
      color: $color-primary;
      font-size: $font-size-md;
    }
  }

  .withdrawal-steps {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 1.5rem;
    padding: 0 2rem;

    &::before {
      content: '';
      position: absolute;
      top: 1rem;
      left: 2rem;
      right: 2rem;
      height: 2px;
      background: #eee;
      z-index: 1;
    }

    .step {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      z-index: 2;

      &.active {
        .step-circle {
          background: $color-primary;
          color: white;
        }
        .step-label {
          color: $color-primary;
          font-weight: 500;
        }
      }

      .step-circle {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.5rem;
        font-size: $font-size-md;
        color: $color-tip;
      }

      .step-label {
        font-size: $font-size-sm;
        color: $color-tip;
        text-align: center;
        white-space: nowrap;
      }
    }
  }

  .withdrawal-limit {
    background: #fff8e6;
    color: #ff9500;
    font-size: $font-size-md;
    padding: 0.6rem 1rem;
    border-radius: 0.5rem;
    margin-bottom: 1.5rem;

    span {
      font-weight: 500;
    }
  }

  .withdrawal-form {
    .form-section {
      margin-bottom: 1.5rem;

      .section-title {
        font-size: $font-size-md;
        color: $color-secondary;
        margin-bottom: 0.5rem;

        .required {
          color: $color-danger;
        }
      }

      .section-value, .confirm-amount {
        font-size: $font-size-xxl;
        font-weight: 600;
        color: $color-primary;
      }

      .account-list {
        .account-item {
          padding: 0.8rem;
          background: #f8f9fa;
          border-radius: 0.6rem;
          border: 1px solid #eee;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;

          &.active {
            border-color: $color-primary;
            background: rgba(167, 115, 154, 0.1);
          }

          .account-icon {
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 0.8rem;
            font-size: $font-size-md;
            font-weight: bold;
            color: white;

            &.bank { background: #4a6baf; }
            &.wx { background: #2aae67; }
            &.zfb { background: #1677ff; }
            &.xzrmb { background: #9c27b0; }
          }

          .account-details {
            flex: 1;

            .account-type {
              font-size: $font-size-md;
              font-weight: 500;
              margin-bottom: 0.2rem;
            }

            .account-number {
              font-size: $font-size-sm;
              color: $color-secondary;
            }
          }
        }
      }

      .amount-input, .password-input {
        position: relative;
        display: flex;
        align-items: center;
        background: white;
        border: 1px solid #ddd;
        border-radius: 0.5rem;
        overflow: hidden;

        .prefix {
          padding: 0 0.8rem;
          font-size: $font-size-md;
          color: $color-secondary;
        }

        input {
          flex: 1;
          padding: 0.8rem 0;
          border: none;
          outline: none;
          font-size: $font-size-md;

          &::placeholder {
            color: $color-disabled;
          }
        }

        .clear-btn {
          padding: 0 0.8rem;
          background: none;
          border: none;
          font-size: $font-size-lg;
          color: $color-tip;
        }
      }

      .input-hint {
        font-size: $font-size-sm;
        color: $color-tip;
        margin-top: 0.3rem;
      }
    }

    .form-notice {
      display: flex;
      background: #fff5f5;
      border: 1px solid #ffdddd;
      border-radius: 0.5rem;
      padding: 0.8rem;
      margin-bottom: 1.5rem;

      .notice-icon {
        width: 1.2rem;
        height: 1.2rem;
        background: $color-danger;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: $font-size-sm;
        margin-right: 0.8rem;
        flex-shrink: 0;
      }

      .notice-content {
        font-size: $font-size-sm;
        color: $color-secondary;

        span {
          color: $color-primary;
          font-weight: 500;
        }
      }
    }

    .form-actions {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.8rem;
      margin-top: 1.5rem;

      .action-btn {
        padding: 0.8rem;
        border: none;
        border-radius: 0.5rem;
        font-size: $font-size-md;
        font-weight: 500;
        transition: all 0.3s ease;

        &.tutorial-btn {
          background: #f0f0f0;
          color: $color-secondary;
        }

        &.record-btn {
          background: #e0e0e0;
          color: $color-title;
        }

        &.submit-btn {
          grid-column: span 2;
          background: $color-primary;
          color: white;

          &:disabled {
            opacity: 0.6;
          }
        }

        &:active {
          transform: scale(0.98);
        }
      }
    }
  }
}

/* 未绑定提示弹窗 */
.binding-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-content {
    position: relative;
    background: white;
    width: 80%;
    max-width: 20rem;
    border-radius: 1rem;
    overflow: hidden;
    animation: scale-in 0.3s ease-out;
  }

  .modal-header {
    padding: 1.2rem 1.5rem 0;
    text-align: center;

    .header-title {
      font-size: $font-size-xl;
      font-weight: 500;
      margin-bottom: 1.2rem;
    }

    .close-btn {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: none;
      border: none;

      svg {
        width: 1rem;
        height: 1rem;
        fill: $color-tip;
      }
    }
  }

  .modal-body {
    padding: 0 1.5rem 1.5rem;

    .modal-message {
      font-size: $font-size-md;
      color: $color-secondary;
      text-align: center;
    }
  }

  .modal-actions {
    padding: 0 1.5rem 1.5rem;

    .action-btn {
      width: 100%;
      padding: 0.8rem;
      background: $color-primary;
      color: white;
      border: none;
      border-radius: 0.5rem;
      font-size: $font-size-md;
      font-weight: 500;
      transition: all 0.3s ease;

      &:active {
        transform: scale(0.98);
      }
    }
  }
}

/* 动画效果 */
.slide-up-enter-active, .slide-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.slide-up-enter-from, .slide-up-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

@keyframes slide-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes scale-in {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>